import { render, staticRenderFns } from "./AllocateCandidateDialog.vue?vue&type=template&id=52d99e24&"
import script from "./AllocateCandidateDialog.vue?vue&type=script&lang=js&"
export * from "./AllocateCandidateDialog.vue?vue&type=script&lang=js&"
import style0 from "./AllocateCandidateDialog.vue?vue&type=style&index=0&id=52d99e24&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports